// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// 引入Element ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 引入swiper
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
// 引入高德地图
import VueAMap from "vue-amap";
//
import App from "./App";


// 引入Vuex
import store from "./store/index";

// 引入normalize.css
import "normalize.css/normalize.css";

// 引入BootStrap
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap/dist/js/bootstrap";

import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs
// 引入v-touch
import VueTouch from "vue-touch";
import router from "./router";
//在main.js添加下面代码
 

Vue.use(VueTouch, { name: "v-touch" });

// import "lib-flexible";

Vue.config.productionTip = false;

/* eslint-disable no-new */
// 全局注入element
Vue.use(ElementUI);
Vue.use(VueAMap);

// 地图组件
VueAMap.initAMapApiLoader({
  key: "66c6ca982a3acec250896daad6ec8dc9",
  plugin: [
    "AMap.Autocomplete",
    "AMap.Geocoder",
    "AMap.Geolocation",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.CircleEditor"
  ],
  uiVersion: "1.0.11",
  v: "1.4.15"
});
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js